import axios from '@/axios';

export default {
  fetchReasons() {
    return axios.get('/api/v1/admins/clinic-churn-reasons');
  },
  createReason(_, data) {
    return axios.post('/api/v1/admins/clinic-churn-reasons', data);
  },
  updateReason(_, data) {
    const { _id, ...payload } = data;
    return axios.patch(`/api/v1/admins/clinic-churn-reasons/${_id}`, payload);
  },
  deleteReason(_, data) {
    return axios.delete(`/api/v1/admins/clinic-churn-reasons/${data._id}`);
  },
};


